import { theme } from '@frontend/theme';
import { CALENDAR_Z_INDICES } from '../../constants';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { useZoomStore } from '../../store/zoom.store';
import { getEffectiveTimeIndicatorLines } from '../../utils';
import { getHourLineBackgroundStyle } from '../styles';

export const GroupHourLines = () => {
  const timeIndicatorLines = useCalendarGridStore((s) => s.timeIndicatorLines);
  const pxPerMinute = useZoomStore((s) => s.pxPerMinute);
  const effectiveTimeIndicatorLines = getEffectiveTimeIndicatorLines(timeIndicatorLines, pxPerMinute);
  if (effectiveTimeIndicatorLines === 'none') return null;

  return (
    <div
      data-group-hour-lines
      css={[
        {
          gridColumn: 1,
          gridRow: '1 / -1',
          borderBottom: `1px solid ${theme.colors.neutral20}`,
          zIndex: CALENDAR_Z_INDICES.gridLines,
        },
        getHourLineBackgroundStyle(effectiveTimeIndicatorLines),
      ]}
    />
  );
};
